import * as React from 'react';
import { ScrollDirection, useScrollDirection } from 'hooks/useScrollDirection';
import SidebarNav from 'components/nav/SidebarNav';
import TabBar from 'components/nav/TabBar';
import TopNav from 'components/nav/TopNav';
import type { TopNavSearchConfig } from 'components/nav/TopNav';
import classNames from 'styles/utils/classNames';

export interface Props {
  children: React.ReactNode;
  isHideSidebar?: boolean;
  isShowTopNav?: boolean;
  handleSignupSuccess?: ({ userId }: { userId: string }) => void | Promise<void>;
  shouldHideNavigation?: boolean;
  shouldHideTabBar?: boolean;
  tabBarHideDirection?: ScrollDirection;
  topNavSearch?: TopNavSearchConfig;
}

const SafeAreaPage: React.FC<Props> = ({
  children,
  isHideSidebar,
  isShowTopNav,
  handleSignupSuccess,
  shouldHideNavigation = false,
  shouldHideTabBar,
  tabBarHideDirection = 'down',
  topNavSearch,
}) => {
  const scrollDirection = useScrollDirection();

  return (
    <div className="safearea-pad-y flex h-full grow flex-col bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary">
      {isShowTopNav && (
        <TopNav
          shouldHideNavigation={shouldHideNavigation}
          handleSignupSuccess={handleSignupSuccess}
          topNavSearch={topNavSearch}
        />
      )}
      {!isHideSidebar && (
        <SidebarNav isTopNavHidden={!isShowTopNav} handleSignupSuccess={handleSignupSuccess} />
      )}
      <div
        className={classNames(
          'flex h-full grow flex-col lg:pb-0',
          !isHideSidebar && 'lg:pl-sidebar',
        )}
      >
        {children}
      </div>
      <div
        className={classNames(
          'fixed bottom-0 left-0 z-20 w-full transition-transform duration-300 ease-in-out md:hidden',
          scrollDirection === tabBarHideDirection ? 'translate-y-[6.5rem]' : 'translate-y-0',
          shouldHideTabBar && 'hidden',
        )}
      >
        <TabBar />
      </div>
      
    </div>
  );
};

export default SafeAreaPage;
